module.exports = __webpack_public_path__ + "img/IND-A-1-V.a15d259c.png";